import { render, staticRenderFns } from "./password-input.vue?vue&type=template&id=670bf6b4&scoped=true&"
import script from "./password-input.vue?vue&type=script&lang=js&"
export * from "./password-input.vue?vue&type=script&lang=js&"
import style0 from "./password-input.vue?vue&type=style&index=0&id=670bf6b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670bf6b4",
  null
  
)

export default component.exports